module.exports = __webpack_public_path__ + "img/shuju_bg.620bd568.png";